module.exports = __webpack_public_path__ + "static/media/creative-commons-nc-jp.96a0dd49.svg";